import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { createEntity, getEntity, reset, updateEntity } from './correction-factor.reducer';

export const CorrectionFactorUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const correctionFactorEntity = useAppSelector(state => state.correctionFactor.entity);
  const loading = useAppSelector(state => state.correctionFactor.loading);
  const updating = useAppSelector(state => state.correctionFactor.updating);
  const updateSuccess = useAppSelector(state => state.correctionFactor.updateSuccess);

  const handleClose = () => {
    navigate('/correction-factor');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.correctionFactor !== undefined && typeof values.correctionFactor !== 'number') {
      values.correctionFactor = Number(values.correctionFactor);
    }

    const entity = {
      ...correctionFactorEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...correctionFactorEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.correctionFactor.home.createOrEditLabel"
            data-cy="CorrectionFactorCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.correctionFactor.home.createOrEditLabel">
              Create or edit a CorrectionFactor
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="correction-factor-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.correctionFactor.correctionFactor')}
                id="correction-factor-correctionFactor"
                name="correctionFactor"
                data-cy="correctionFactor"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.correctionFactor.effectiveDate')}
                id="correction-factor-effectiveDate"
                name="effectiveDate"
                data-cy="effectiveDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.correctionFactor.expirationDate')}
                id="correction-factor-expirationDate"
                name="expirationDate"
                data-cy="expirationDate"
                type="date"
              />
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/correction-factor"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CorrectionFactorUpdate;
